import React from 'react';
import { Box, Button } from '@drone-js/core';
import { connect, useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { mapDispatchToProps, Props } from 'component/page/detail/Review/ReviewSummary/ReviewSummary.selectors';
import ReviewOverviewCarousel from 'component/page/detail/Review/ReviewOverviewCarousel/ReviewOverviewCarousel';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesSeeAllReviewButtonClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesSeeAllReviewButtonClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import ReviewDistribution from 'component/page/detail/Review/ReviewDistribution/ReviewDistribution';

const ReviewSummary: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    const onReviewSectionClick = () => {
        trackElementEvent<ActivitiesSeeAllReviewButtonClickEventActivitiesFieldsV1>(ActivitiesSeeAllReviewButtonClickEventActivitiesManifestV1.ids, {});
        props.showReviewOverlay();
    };

    return (
        <div data-testid="activities-review-summary">
            <Box my="16">
                <ReviewDistribution />
            </Box>
            <ReviewOverviewCarousel />
            <Button
                data-element-name="activities-see-all-review-button"
                data-testid="activities-see-all-review-button"
                aria-label={cms[120407]}
                variant="label"
                hierarchy="secondary"
                size="m"
                label={cms[120407]}
                onClick={onReviewSectionClick}
                my="12"
                width="parent-fit"
            />
        </div>
    );
};

ReviewSummary.displayName = 'ReviewSummary';
export default connect(undefined, mapDispatchToProps)(ReviewSummary);
